import React from 'react';

import PropTypes from 'prop-types';

import { LightDiskBadge } from 'apps/promo/components/common/fromAuth/LightDiskBadge/LightDiskBadge';
import { LightFlagIcon } from 'apps/promo/components/common/fromAuth/LightFlagIcon/LightFlagIcon';
import { LightPanel } from 'apps/promo/components/common/fromAuth/LightPanel/LightPanel';
import { DiskBadgeWrapper, PanelRow, PanelRightBlock, LightSelectedDiskBadge } from 'apps/promo/components/common/fromAuth/LightPanel/styles';
import { LightText } from 'apps/promo/components/common/fromAuth/LightText/LightText';
import { getHighlightedText } from 'apps/promo/helpers/utils';

export const PromoCountryItemPanel = (props) => {
    return (
        <LightPanel onClick={props.onClick} type={props.to ? 'reactLink' : 'link'} to={props.to} isHoverable negativeMargin>
            <PanelRow>
                <PanelRow alignStart>
                    <DiskBadgeWrapper>
                        <LightFlagIcon name={props.flagIconName} size="40px" />
                        {props.isSelectedCountry && (
                            <LightSelectedDiskBadge>
                                <LightDiskBadge variant="selectedPassive" iconName="check" />
                            </LightSelectedDiskBadge>
                        )}
                    </DiskBadgeWrapper>
                    {!!props.query ? (
                        <>{getHighlightedText(props.query, props.countryName, 'lightText', { smallCaps: true })}</>
                    ) : (
                        <LightText>{props.countryName}</LightText>
                    )}
                </PanelRow>
                <PanelRightBlock>
                    {!!props.query ? (
                        <>
                            {getHighlightedText(props.query, props.countryPrefix, 'lightText', {
                                lightTextColor: 'secondary',
                                smallCaps: true,
                            })}
                        </>
                    ) : (
                        <LightText color="secondary" smallCaps>
                            {props.countryPrefix}
                        </LightText>
                    )}
                </PanelRightBlock>
            </PanelRow>
        </LightPanel>
    );
};

PromoCountryItemPanel.propTypes = {
    onClick: PropTypes.func,
    to: PropTypes.string,
    flagIconName: PropTypes.string,
    countryName: PropTypes.string,
    countryPrefix: PropTypes.string,
    isSelectedCountry: PropTypes.bool,
    query: PropTypes.string,
};
